import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export default makeStyles(
  (theme) => ({
    root: {
      padding: theme.spacing(1, 0, 1, 1),
      height: 38,
      color: theme.palette.common.white,

      '&$selected': {
        backgroundColor: theme.palette.darkHoverSecondary,
        fontWeight: theme.typography.fontWeightMedium,
      },

      '&:hover': {
        backgroundColor: theme.palette.darkHoverSecondary,

        '& $menuButton': {
          opacity: 1,
        },
      },
    },
    disabled: {},
    selected: {},
    first: {
      textTransform: 'capitalize',
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(10),
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '4px',
      color: COLORS.gray.black,
      backgroundColor: COLORS.primary.light,
      padding: theme.spacing(0.75),
      fontWeight: theme.typography.fontWeightMedium,
      width: 24,
      height: 24,
      marginRight: theme.spacing(1),
    },
    text: {
      fontSize: theme.typography.pxToRem(14),
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      color: 'inherit',
      fontWeight: 'inherit',
    },
    menuButton: {
      opacity: 0,

      '& > button ': {
        color: theme.palette.common.white,
        padding: theme.spacing(1),
      },
    },
  }),
  { name: 'WorkspaceMenuItem' }
);
